jQuery(document).ready(function ($) {
    var $popup = $('#popup_avertissement_dentaire');

    if (!$popup.length) {
        return;
    }

    if (sessionStorage.getItem('dental_warning_dismissed') === '1') {
        return;
    }

    $popup.removeAttr('hidden');
    $('body').addClass('no-scroll');

    function closePopup() {
        $popup.attr('hidden', true);
        $('body').removeClass('no-scroll');
        sessionStorage.setItem('dental_warning_dismissed', '1');
    }

    function redirectHome() {
        var url = $popup.find('.popup_avertissement_redirect').data('url') || '/';
        window.location.href = url;
    }

    $popup.find('.popup_avertissement_close').on('click', closePopup);
    $popup.find('.popup_avertissement_redirect').on('click', redirectHome);
});